import React from "react" 
import { graphql } from 'gatsby'
import Layout from 'components/Layout'
import PropTypes from 'prop-types'
import Table from 'components/Table'
import TabBar from 'components/TabBar'
import { getType, summaryTabNames } from '../util'

function createRows(vehicleDict, customDict) {
	var data = []
	for(var key in vehicleDict) {
		const vehicle = vehicleDict[key]

		var query = vehicle.vehicleData.unitNumber
		query += getType(vehicle.vehicleData.type, customDict)
		query += vehicle.lastDate
		query += vehicle.lastOdometer
		query += vehicle.lastStatus
		query += vehicle.lastDone
		query += vehicle.vehicleData.year
		query += vehicle.vehicleData.jurisdiction
		query += vehicle.vehicleData.lic
		query += vehicle.vehicleData.vin
		query += vehicle.vehicleData.make
		query = query.toLowerCase()

		data.push({
			to:"/vehicle",
			id: vehicle.id,
			vehicleId: vehicle.vehicleData.unitNumber,
			type: getType(vehicle.vehicleData.type, customDict),
			lastDate: vehicle.lastDate,
			odometer: vehicle.lastOdometer,
			description: "license: " + vehicle.vehicleData.lic,
			status: vehicle.lastStatus,
			doneLast: vehicle.lastDone,
			query: query
		})
	}
	
	return data
}

const headCells = [
	{ id: 'vehicleId', numeric: false, disablePadding: true, label: 'Vehicle' },
	{ id: 'type', numeric: true, disablePadding: false, label: 'Type' },
	{ id: 'lastDate', numeric: true, disablePadding: false, label: 'Last Done On' },
	{ id: 'odometer', numeric: true, disablePadding: false, label: 'Odometer' },
	{ id: 'status', numeric: true, disablePadding: false, label: 'Status' },
	{ id: 'doneLast', numeric: true, disablePadding: false, label: 'Last Done Since' },
  ];

function DashboardIndex({ data, dicts, user, location, fetchInspections, done, nInsp }) {
	const { inspectionDict, vehicleDict, customDict } = dicts
	const rows = createRows(vehicleDict, customDict)
	const { title } = data.site.siteMetadata

	var accountText = "Free Days Left: " + user.daysLeft
    if (user.tier === "ppv") {
        accountText = "Vehicles Left: " + user.vehiclesLeft
    } else if (user.tier === "ppi") {
        accountText = "Inspections Left: " + user.inspectionsLeft
    }

	return (
		<Layout location={location} dicts={dicts} title={title}>
			
			<TabBar tabNames={summaryTabNames} index={0}/>
			{/* <Grid lg={12} xs={12} item align="center">
				<Button variant="contained" color="primary" disabled={done}>
					<Link 
						style={{ 
							textDecoration: 'none', 
							color: 'inherit' 
						}} 
						to='/' 
						onClick={() => {
							fetchInspections()
						}}>
						Fetch More Inspections
					</Link>
				</Button>
			</Grid> */}
			<Table title={"Vehicle Summary - " + accountText} 
			headCells={headCells} 
			rows={rows} 
			show={true} 
			done={done}
			nInsp={Object.keys(inspectionDict).length}
			fetchInspections={()=>fetchInspections()}/>

		</Layout>
	)
}
DashboardIndex.propTypes = {
	data: PropTypes.object.isRequired,
	location: PropTypes.object,
}
export const pageQuery = graphql`
	query {
		site {
			siteMetadata {
				title
			}
		}
	}
`
export default DashboardIndex
